import { logStartUsage } from './logStartUsage';
import { type CustomDataMap, DatapointStatus, type TraceErrorObject } from 'owa-analytics-types';
import type { AnalyticsEventNames, AnalyticsCoreEventNames } from 'owa-analytics-events';
import type { MailboxInfo } from 'owa-client-types';

export class LogStartPerformanceUsage {
    private eventName: AnalyticsEventNames | AnalyticsCoreEventNames;
    private mailboxInfo: MailboxInfo | undefined;
    private customData: CustomDataMap = {};
    private hasEnded = false;
    private startTime: number;

    constructor(
        eventName: AnalyticsEventNames | AnalyticsCoreEventNames,
        mailboxInfo?: MailboxInfo
    ) {
        this.eventName = eventName;
        this.mailboxInfo = mailboxInfo;
        this.startTime = Date.now();
    }

    addCheckpoint(name: string): void {
        this.customData[name] = Date.now() - this.startTime;
    }

    addCustomProperty(key: string, value: string | number | boolean | undefined): void {
        this.customData[key] = value;
    }

    end(): void {
        if (!this.hasEnded) {
            this.hasEnded = true;
            this.customData['Duration'] = Date.now() - this.startTime;
            this.customData['Status'] = DatapointStatus.Success;
            logStartUsage(this.eventName, this.mailboxInfo, this.customData);
        }
    }

    endWithError(status: DatapointStatus, error?: TraceErrorObject): void {
        if (!this.hasEnded) {
            this.hasEnded = true;
            this.customData['Duration'] = Date.now() - this.startTime;
            this.customData['Status'] = status;

            if (error) {
                this.customData['ErrorMessage'] = error.message;
                this.customData['ErrorDetails'] = error.stack;
                this.customData['AdditionalInfo'] = JSON.stringify(error.additionalInfo);
            }
            logStartUsage(this.eventName, this.mailboxInfo, this.customData);
        }
    }
}
